// ============================================================
// demo-seed — populate the mock stores for ?demo= links
// ============================================================
// So a shareable demo link (and the walkthrough screenshots) show
// populated Service Requests + admin Starlink Credentials instead of
// empty states. Idempotent — only writes if the store is empty. Demo
// mode only; never runs against real data.

export function seedDemoData(accountNumber) {
  const now = Date.now();
  // ── Service requests ──
  try {
    const KEY = 'netcom_connect_service_requests';
    if (!localStorage.getItem(KEY)) {
      const mk = (id, type, label, payload, notes, ageMin) => {
        const at = new Date(now - ageMin * 60000).toISOString();
        return {
          id, accountNumber, requesterEmail: 'morgan.patel@globaltrade.example',
          type, typeLabel: label, payload, notes: notes || '',
          status: 'submitted',
          statusHistory: [{ status: 'submitted', at, by: 'morgan.patel@globaltrade.example' }],
          createdAt: at, updatedAt: at,
          expiresAt: new Date(now - ageMin * 60000 + 14 * 86400000).toISOString(),
        };
      };
      localStorage.setItem(KEY, JSON.stringify([
        mk('REQ-A1B2-PLAN', 'plan_change', 'Change my plan',
           { serviceLineNumber: 'SL-OG-001', newPlan: 'Global Priority 5TB', effectiveDate: 'next_cycle' }, '', 45),
        mk('REQ-C3D4-TOPUP', 'topup', 'Add 50GB top-up',
           { serviceLineNumber: 'SL-OG-002' }, 'Site running hot this cycle', 180),
      ]));
    }
  } catch { /* ignore */ }

  // ── Admin Starlink Service Account registry ──
  try {
    const KEY = 'netcom_connect_starlink_creds_demo';
    if (!sessionStorage.getItem(KEY)) {
      const sa = (acct, label, hint, scopes) => ({
        account_number: acct, label, status: 'provisioned', scopes,
        client_id_hint: hint, created_at: new Date(now).toISOString(),
        updated_at: new Date(now).toISOString(),
        last_polled_at: new Date(now - 32000).toISOString(), last_error: null,
      });
      sessionStorage.setItem(KEY, JSON.stringify([
        sa('ACC-DF-1042', 'Acme Energy', 'clid_9f2a', ['telemetry', 'device-command']),
        sa('ACC-DF-1188', 'Tallgrass Midstream', 'clid_3b8d', ['telemetry']),
      ]));
    }
  } catch { /* ignore */ }
}
